import { render } from "./Info.vue?vue&type=template&id=7396f892&ts=true"
import script from "./Info.vue?vue&type=script&lang=tsx"
export * from "./Info.vue?vue&type=script&lang=tsx"

import "./Info.vue?vue&type=style&index=0&id=7396f892&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__